<template>
  <content-container :overlay="false">
    <!-- Заголовок если сессий много --------------------------------------------->
    <transition name="fadesession">
      <div
        v-if="sessions.length > 2"
        class="d-flex justify-content-between align-items-center"
      >
        <div>
          <h4>{{ $t("profile.sessions.many.h", [sessions.length - 1]) }}</h4>
          <p class="text-secondary">
            {{ $t("profile.sessions.many.desc") }}
          </p>
        </div>
        <b-button @click="revokeAll()">{{
          $t("profile.sessions.many.action")
        }}</b-button>
      </div>
    </transition>
    <transition-group name="fadesession">
      <simple-card left v-for="item in sessions" :key="item.id">
        <template v-slot:pane>
          <div class="icon"></div>
        </template>
        <template v-slot:title>
          <div class="mb-4">
            <template v-if="item.current">{{
              $t("profile.sessions.current.h", [item.ip])
            }}</template>
            <div
              v-else
              class="d-flex justify-content-between align-items-center"
            >
              IP: {{ item.ip }}

              <b-button
                size="sm"
                @click="revoke(item)"
                :disabled="item.loading"
                >{{ $t("profile.sessions.action") }}</b-button
              >
            </div>
          </div>
        </template>
        <template v-slot:description>
          <div class="mb-3">{{ item.system }}</div>
          <div>
            <div class="mb-2">
              {{
                $t("profile.sessions.start", [
                  $d(new Date(item.created_on), "long"),
                ])
              }}
            </div>
            <div>{{ $t("profile.sessions.lastSeen", [lastSeen(item)]) }}</div>
          </div>
        </template>
      </simple-card>
    </transition-group>
  </content-container>
</template>

<script>
import ContentContainer from "../ContentContainer.vue";
import SimpleCard from "../SimpleCard.vue";
import {
  URL_GET_USER_SESSIONS,
  URL_REVOKE_ALL_USER_SESSIONS,
  URL_REVOKE_USER_SESSION,
} from "@/globals";

export default {
  components: { SimpleCard, ContentContainer },
  name: "UserSessions",
  data() {
    return {
      current_id: "",
      sessions: [],
    };
  },
  methods: {
    revokeAll: function () {
      document.activeElement.blur();
      this.$delete(URL_REVOKE_ALL_USER_SESSIONS, true, false)
        .then(() => {
          this.sessions.splice(1, this.sessions.length - 1);
        })
        .catch((e) => {
          this.$alert.show(e);
        });
    },
    revoke: function (item) {
      document.activeElement.blur();
      item.loading = true;
      this.$delete(URL_REVOKE_USER_SESSION.format(item.id), true, false)
        .then((result) => {
          let idx = this.sessions.findIndex((i) => i.id == result.id);
          if (idx) this.sessions.splice(idx, 1);
        })
        .catch((e) => {
          item.loading = false;
          this.$alert.show(e);
        });
    },
    lastSeen: function (item) {
      let delta = Date.now() - new Date(item.updated_on).getTime();
      var seconds = Math.floor(delta / 1000);
      var minutes = delta / 60000;
      var hours = delta / 3600000;
      var days = delta / 86400000;
      if (seconds <= 60) return this.$tc("profile.sessions.m", 1);
      if (days >= 1) {
        days = Math.floor(days);
        hours = Math.floor(hours) - days * 24;
        minutes = Math.floor(minutes) - days * 24 * 60 - hours * 60;
        let result = this.$tc("profile.sessions.d", days);
        if (hours > 0) {
          result = +" " + this.$tc("profile.sessions.h", hours);
        }
        if (minutes > 0) {
          result = +" " + this.$tc("profile.sessions.m", minutes);
        }
        return result;
      } else {
        if (hours >= 1) {
          hours = Math.floor(hours);
          minutes = Math.floor(minutes) - hours * 60;
          if (minutes > 0) {
            return (
              this.$tc("profile.sessions.h", hours) +
              " " +
              this.$tc("profile.sessions.m", minutes)
            );
          } else {
            return this.$tc("profile.sessions.h", hours);
          }
        } else if (minutes >= 1) {
          minutes = Math.floor(minutes);
          return this.$tc("profile.sessions.m", minutes);
        } else {
          return this.$tc("profile.sessions.s", seconds);
        }
      }
    },
  },
  created() {
    // Токен должен быть свежим, перечитаем пользователя с сервера
    this.$get(URL_GET_USER_SESSIONS, true)
      .then((result) => {
        this.current_id = result.id;
        let items = result.items;
        // Текущая должна быть первой в списке
        items.sort((x, y) => {
          return x.id == this.current_id ? -1 : y.id == this.current_id ? 1 : 0;
        });
        items.forEach((e) => {
          e.current = e.id == this.current_id ? true : false;
          e.loading = false;
          e.deleting = false;
        });
        this.sessions = result.items;
      })
      .catch((e) => {
        // Странный случай, предложим войти в кабинет
        this.$router.push({ name: "sign-in" });
        this.$alert.show(e);
      });
  },
};
</script>

<style scoped>
.icon {
  min-width: 120px;
  min-height: 120px;
  content: "";
  background-image: url(/workstation.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.fadesession-enter-active,
.fadesession-leave-active {
  transition: opacity 0.5s;
}
.fadesession-enter,
.fadesession-leave-to {
  opacity: 0.1;
}
</style>